<template>
  <div class="rew19_containSns_title">
    <ul class="rew19_sharesns">
      <li><a id="kakaoLinkBtn" @click="onClickShareSns('5')"><img src="https://resource2018.nuskinkorea.co.kr/images/aro/sns_talk.png" alt="공유_카카오톡"></a></li>
      <li><a id="facebookLinkBtn" @click="onClickShareSns('1')"><img src="https://resource2018.nuskinkorea.co.kr/images/aro/sns_face.png" alt="공유_페이스북"></a></li>
      <li><a id="kakaoStoryLinkBtn" @click="onClickShareSns('2')"><img src="https://resource2018.nuskinkorea.co.kr/images/aro/sns_story.png" alt="공유_카카오스토리"></a></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'FourplusIntroduceSns',  
  components: {  },
  props: {
    snsLinkUrl: {
      type: String,
      required: true
    },
    snsTitle: {
      type: String,
      required: true
    },
    snsImgUrl: {
      type: String,
      required: true
    },    
  },
  data() {
    return {
    }
  },
  mounted() {
    let _this = this;

    _this.$aroSnsInit();
  },
  methods :{
    //Sns 공유
    onClickShareSns(type){
      let _this = this;      
      
      _this.$aroSnsShareAction(
        _this.snsTitle, //snsTitle
        _this.snsLinkUrl, //shareLinkUrl
        _this.snsImgUrl, //shareImgUrl
        type //snsType
      );
    },
  }
}
</script>
<style>
#kakaoLinkBtn, #facebookLinkBtn, #kakaoStoryLinkBtn{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/info/snsLink.vue